import script from "./AiChatbotSwitzerland.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChatbotSwitzerland.vue?vue&type=script&setup=true&lang=js"

import "./AiChatbotSwitzerland.vue?vue&type=style&index=0&id=43bd3deb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43bd3deb"]])

export default __exports__